import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentToken, selectLoggedOut } from './authSlice';
import { useRefreshMutation } from '../../api/authApiSlice';
import FullScreenLoader from '../../common/components/FullScreenLoader';

const RequireAuth = () => {
	const location = useLocation();

	const token = useSelector(selectCurrentToken);
	const loggedOut = useSelector(selectLoggedOut);
	const refreshing = useRef(false);

	const [refresh, { isSuccess, isLoading, isError }] = useRefreshMutation();
	useEffect(() => {
		const verifyRefreshToken = async () => {
			// dedupes the double effect invocation in dev Strict Mode
			if (refreshing.current) return;
			refreshing.current = true;
			console.log('verifying refresh token');
			try {
				await refresh();
			} catch (err) {
				console.error(222, err);
			} finally {
				refreshing.current = false;
			}
		};

		if (!token && !loggedOut) {
			verifyRefreshToken();
		}

		// eslint-disable-next-line
	}, [token, loggedOut]);

	if (loggedOut) {
		// deliberate logout: drop the "from" location so the next login always
		// lands on the user's default page instead of the previous page
		return <Navigate to='/login' replace />;
	} else if (isLoading) {
		return <FullScreenLoader />;
	} else if (isError) {
		return <Navigate to='/login' state={{ from: location }} replace />;
	} else if (isSuccess || token) {
		return <Outlet />;
	} else {
		return <></>;
	}
};

export default RequireAuth;
